<template>
    <svg height="20.835" viewBox="0 0 20.835 20.835" width="20.835" xmlns="http://www.w3.org/2000/svg">
        <path
            id="Icon_material-keyboard-hide"
            d="M21.751,4.5H5.083A2.081,2.081,0,0,0,3.01,6.583L3,17a2.09,2.09,0,0,0,2.083,2.083H21.751A2.09,2.09,0,0,0,23.835,17V6.583A2.09,2.09,0,0,0,21.751,4.5ZM12.376,7.625h2.083V9.709H12.376Zm0,3.125h2.083v2.083H12.376ZM9.25,7.625h2.083V9.709H9.25Zm0,3.125h2.083v2.083H9.25ZM8.209,12.834H6.125V10.75H8.209Zm0-3.125H6.125V7.625H8.209ZM17.584,17H9.25V14.917h8.334Zm0-4.167H15.5V10.75h2.083Zm0-3.125H15.5V7.625h2.083Zm3.125,3.125H18.626V10.75H20.71Zm0-3.125H18.626V7.625H20.71ZM13.417,25.335l4.167-4.167H9.25Z"
            data-name="Icon material-keyboard-hide"
            fill="#afafaf"
            transform="translate(-3 -4.5)"
        />
    </svg>
</template>

<script>
export default {
    name: "HideChat",
};
</script>
